import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

import { ItineraryDateViewMapModule } from '@hiptraveler/features/leaflet-map';
import { ActivityDayListModule, ActivityDateListModule } from '@hiptraveler/features/itinerary';
import { EditableSelectionsModule, StoryImageModule } from '../common';
import { CustomMapAutocompleteModule } from '@hiptraveler/features/custom-map-autocomplete';
import { ButtonsModule } from '@hiptraveler/ui/buttons';

import { ComposeItineraryFormComponent } from './compose-itinerary-form.component';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatProgressSpinnerModule,
  TranslateModule
];

const LIBRARIES = [
  ItineraryDateViewMapModule,
  ActivityDayListModule,
  ActivityDateListModule,
  EditableSelectionsModule,
  StoryImageModule,
  CustomMapAutocompleteModule,
  ButtonsModule
];

const COMPONENTS = [
  ComposeItineraryFormComponent
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    ComposeItineraryFormComponent
  ]
})
export class ComposeItineraryModule { }
